import { UAParser } from 'ua-parser-js'
import { Config } from 'modules/config/state/config-types'
import { PaymentMethod, PaymentProcessor } from 'models/ChargeIntent'
import { PaymentDetails } from './payment-details-types'

export const makePaymentDetailsInitialState = (config: Config): PaymentDetails => {
  const hasDW = shouldShowDW(config)

  return {
    method: null,
    isAmex: false,
    processor: PaymentProcessor.STRIPE,
    type: hasDW ? PaymentMethod.DW : PaymentMethod.CC,
  }
}

/**
 * Helper function to determine if DW (Digital Wallet) should be available
 * based on config and device type. DW is hidden on desktop devices.
 */
export const shouldShowDW = (config: Config): boolean => {
  // Check if DW is enabled in config
  const isDWEnabledInConfig = !!config.payment.activeMethods.find(
    (m) => m.type === PaymentMethod.DW,
  )

  if (!isDWEnabledInConfig) {
    return false
  }

  if (config.isEmbedded) return true

  // Check if user is on mobile device
  const parser = new UAParser()
  const device = parser.getDevice()
  const isMobile = device.type === 'mobile' || device.type === 'tablet'

  // Only show DW on mobile devices
  return isMobile
}
